export default __webpack_public_path__ + "9740815cc9d8c3a568317aad5f265f05.svg";